<template>
  <div class="news">
    <div class="header">
      <div
        class="item"
        v-for="item in titleList"
        :key="item.id"
        :class="titleId == item.id ? 'active' : ''"
        @click="clickTab(item.id)"
      >
        <div>{{ item.title }}</div>
      </div>
    </div>

    <div class="body">
      <div class="left">
        <div class="list">
          <router-link
            v-for="item in titleId == 1 ? newsList : newsList1"
            :key="item.id"
            :to="{ path: item.path, query: { id: item.id } }"
          >
            <div class="item">
              <div class="item-left">
                <img :src="item.logo" alt="" />
              </div>
              <div class="item-center">
                <div class="title">{{ item.title }}</div>
                <div class="date">{{ item.date }}</div>
                <div class="text">{{ item.text }}</div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilenewsLogo1 from "../../../assets/dynamic/mobilenewsLogo1.png";
import mobilenewsLogo2 from "../../../assets/dynamic/mobilenewsLogo2.png";
import mobilenewsLogo3 from "../../../assets/dynamic/mobilenewsLogo3.png";
import mobilenewsLogo4 from "../../../assets/dynamic/mobilenewsLogo4.png";
import mobilenewsLogo5 from "../../../assets/dynamic/mobilenewsLogo5.png";
import mobilenewsLogo6 from "../../../assets/dynamic/mobilenewsLogo6.png";
import mobilenewsLogo7 from "../../../assets/dynamic/mobilenewsLogo7.png";
import mobilenewsLogo8 from "../../../assets/dynamic/mobilenewsLogo8.png";
import mobilenewsLogo9 from "../../../assets/dynamic/mobilenewsLogo9.png";
import mobilenewsLogo10 from "../../../assets/dynamic/mobilenewsLogo10.png";

export default {
  setup() {
    return reactive({
      demoShow: false,
      titleId: 1,
      titleList: [
        {
          id: 1,
          title: "行业新闻",
        },
        {
          id: 2,
          title: "公司动态",
        },
      ],
      newsList: [
        {
          id: 0,
          title: "传统物业与现在的智慧物业相比，智慧物业管理系统有哪些优势？",
          text: "智慧物业是利用互联网等高科技手段，让普通物业管理模式变得更加智能化。其实，好的智慧物业离我们的生活还很遥远，但是使用智慧物业管理系统可以在一定程度上形成智慧物业模式。智慧物业管理系统的优势在于可以提升物业管理人员的工作效率和业主的生活质量。传统物业管理的缺点：1、人工成本高：物业服务的本质决定了其价值应该通过人来实现。传统物业管理在收费、访客登记、数据统计等日常工作场景中主要依靠大量人力。不仅耗费大量人力，而且效率低下，容易出错。2、服务工作效率低：业主报事报修需要到物业办公室或电话进行人工指令，物业工作人员不明原因导致处理速度慢、进度难以跟踪、无法落实处理结果......",
          date: "2022/07/05",
          logo: mobilenewsLogo1,
          path: "/mobile/dynamic/newsdetails",
        },
        {
          id: 1,
          title: "10大物业管理软件排名",
          text: "排名或者榜单之类应该由行业权威部门来弄的，如题，从来没有国家或行业权威对物业管理软件进行过相关排名，所以，物业软件排名根本没有标准答案，适合的就是好的。根据公司功能需求和预算，选择合适的软件即可......",
          date: "2022/07/04",
          logo: mobilenewsLogo2,
          path: "/mobile/dynamic/newsdetails",
        },
        {
          id: 2,
          title: "智慧物业管理系统建设智慧社区为何这么受欢迎？",
          text: "近几年信息技术飞速发展，数字化产品也逐渐呈现在人们眼前，各种智能机器人、智能检测体温设备、无人机驾驶汽车的出现都让大家感受到科技给生活带来的便利。在这样的科技大环境下，智慧社区也加入了其中，从信息化管理到智能设备建设......",

          date: "2022/06/28",
          logo: mobilenewsLogo3,
          path: "/mobile/dynamic/newsdetails",
        },
        {
          id: 3,
          title: "疫情之下，智慧物业管理系统的建设，有了更多的“用武之地”",
          text: "疫情以来，随着社区站在外防内防扩散的第一线，物业服务企业的精准排查、消防消杀、严格门禁、提供上门服务等能力也得到检验......",
          date: "2022/06/15",
          logo: mobilenewsLogo4,
          path: "/mobile/dynamic/newsdetails",
        },
        {
          id: 4,
          title: "好的社区管理系统应该具备什么特点",
          text: "几年来随着科学技术的飞速发展，很多的街道社区办事处或多或少的受到上面的影响或者是为了加快智慧街道等理念的落实，大多都开始引入了社区管理系......",

          date: "2022/06/09",
          logo: mobilenewsLogo5,
          path: "/mobile/dynamic/newsdetails",
        },
      ],
      newsList1: [
        {
          id: 0,
          title: "宝山区11个消防救援站WIFI6项目",
          text: "为了对消防员绿色上网行为进行更好的管理，上海畅月物业管理有限公司响应宝山消防站的号召，对宝山11个消防站点及保障大队室内......",
          date: "2022/06/09",
          logo: mobilenewsLogo6,
          path: "/mobile/dynamic/dynamicdetails",
        },
        {
          id: 1,
          title: "宝山八村高空抛物系统集成服务项目",
          text: "2019年11月，最高人民法院印发《关于依法妥善审理高空抛物、坠物案件的意见》，明确对于故意高空抛物者，根据具体情形按照以危险方法危害公共安全罪、故意伤害罪或故意杀人罪论处，打开社区高度重视高空抛物监控的需求重要性......",
          date: "2022/06/15",
          logo: mobilenewsLogo7,
          path: "/mobile/dynamic/dynamicdetails",
        },
        {
          id: 2,
          title: "中冶祥腾宝月花园小区地下车库自动识别道闸系统",
          text: "宝月花园小区地处宝山月浦镇，小区地址位于申浦路，小区道路的合理组织，休闲设施的精心安排，提供自然、舒适的居住环境......",
          date: "2022/07/04",
          logo: mobilenewsLogo8,
          path: "/mobile/dynamic/dynamicdetails",
        },
        {
          id: 3,
          title: "香岛原墅小区智能安防系统建设",
          text: "2021年8月1号国家应急管理部公布的《高层民用建筑消防安全管理规定》禁止在高层民用建筑公共门厅、疏散走道、楼梯间、安全出口停放电动自行车或者为电动自行车充电......",
          date: "2022/06/28",
          logo: mobilenewsLogo9,
          path: "/mobile/dynamic/dynamicdetails",
        },
        {
          id: 4,
          title: "惠阳苑竣工案例",
          text: "和谐社会，平安为先，经济发展，稳定为要，创建智能化平安小区工程是加快经济发展，保障人民群众安居乐业的重要载体。惠阳苑小区是上海市宝山区推动平安社区智能化管理系统重点示范工程......",
          date: "2022/07/04",
          logo: mobilenewsLogo10,
          path: "/mobile/dynamic/dynamicdetails",
        },
      ],
    });
  },
  methods: {
    clickTab(id) {
      this.titleId = id;
    },
  },
};
</script>

<style scoped>
.news {
  width: 100%;
  margin: 24px auto;
}

.header {
  width: 92vw;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
  border-bottom: 1px solid #dce1e8;
}
.header .item {
  padding: 8px 0;
  font-size: 16px;
  cursor: pointer;
}
.header .active {
  border-bottom: 2px solid #248efb;
  color: #248efb;
}

.body {
  width: 92vw;
  margin: 0 auto;
  margin-top: 16px;
}
.body .left .demo .box {
  padding-bottom: 60px;
  border-bottom: 1px solid #dce1e8;
}
.body .left .demo .demo-left img {
  width: 100%;
  margin-right: 10px;
}
.body .left .demo .demo-right {
  position: relative;
}
.body .left .demo .demo-right .title {
  font-size: 20px;
  color: #333;
}
.body .left .demo .demo-right .text {
  font-size: 14px;
  color: #3d3d3d;
  margin-top: 30px;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 15;
}
.body .left .demo .demo-right .date {
  text-align: center;
  width: 80px;
  height: 80px;
  background: #f5f7fa;
  position: absolute;
  bottom: 0;
}
.body .left .demo .demo-right .date div:nth-of-type(1) {
  font-size: 30px;
  color: #495a6c;
  padding-top: 15px;
}
.body .left .demo .demo-right .date div:nth-of-type(2) {
  font-size: 16px;
  color: #495a6c;
}
.body .left .list .item {
  margin-bottom: 24px;
}
.body .left .list .item .item-left img {
  width: 100%;
  margin-top: 16px;
}
.body .left .list .item .item-center .title {
  font-size: 14px;
  color: #333;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 2;
  margin-top: 12px;
  font-weight: 600;
}
.body .left .list .item .item-center .date {
  font-size: 12px;
  color: #495A6C;
  margin-top: 6px;
}
.body .left .list .item .item-center .text {
  color: #3d3d3d;
  font-size: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 3;
  margin-top: 6px;
}
</style>
